const Payment = {
  PAYMENT_METHOD: {
    CARD: '신용/체크카드',
    TRANSFER: '계좌이체',
    VIRTUAL_ACCOUNT: '가상계좌',
    MOBILE: '휴대폰결제',
    TOSS_PAY: '토스페이',
    CASH: '현금',
    NAVER_PAY: '네이버페이',
    KAKAO_PAY: '카카오페이',
    APPLE_PAY: '애플페이',
    SAMSUNG_PAY: '삼성페이',
    POINT: '포인트',
    GIFT_CARD: '기프트카드',
    PAYPAL: '페이팔',
    INSTALLMENT: '할부',
    ALI_PAY: '알리페이',
    WECHAT_PAY: '위챗페이',
    COOP: '쿠프',
    INFI: '스마트인피니',
    INFI_OPTIONAL: '스마트인피니 현금영수증',
    PAYS: '페이즈',
    PCI_PAY: '페이코인',
    RHEA_PAY: '레아페이',
    ZERO_PAY: '제로페이',
    FUN: '즐거운',
    CJONE_PAY: '씨제이원페이',
    VENDYS: '식권대장',
    GIFTI_SHOW: 'KT 기프티쇼',
    PAYCO: '페이코',
    KONPAY: '콘페이',
    SMARTCON: '스마트콘',
    SEOUL_PAY: '서울페이',
    SSG_PAY: '신세계페이',
    L_PAY: '롯데페이',
    JM_PAY: '제이엠페이',
    PRESENT: '선물하기',
  },
};

export default Payment;
